<template>
    <div class="flex-grid control-ie" :class="{'flex-grid--reduced-bottom-margin' : tableControl || noFlexMargin}">
        <div v-if="!tableControl" class="flex-grid__g-2 flex-grid--input-label">
            <label :for="name">
                <p :class="{'u-vertical-centre-transform-desktop no-margin-desktop' : verticalCentre}">{{ label }}<span
                        class="flex-grid--input-label-required" v-if="isRequired"> *</span></p>
            </label>
        </div>
        <div v-if="!tableControl" class="flex-grid__g-7 a-form-inputs"
             :class="['a-form-inputs--' + beforeAfter, {'u-no-margin' : !iconSpace }]">
            <slot></slot>
        </div>
        <div v-else class="flex-grid__g-9 a-form-inputs" :class="['a-form-inputs--' + beforeAfter, {'u-no-margin' : !iconSpace || theCurrentWidth < 1024}]">
            <slot></slot>
        </div>
        <div v-if="iconSpace || theCurrentWidth < 1024">
            <div @click="toggleModal" v-if="tipShow">
                <icon-tooltip :tooltip-name="tipName" :tooltip-text="tipText" :side="tipSide" :text-width="tipWidth"
                              :icon-type="tipIcon"></icon-tooltip>
            </div>
            <div v-else :style="{width: '26px'}"></div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Modal from 'components/modal/Modal.vue';
    import IconTooltip from 'components/IconTooltip.vue';
    import claimsDashboardIcons from 'pages/claims-dashboard/components/Icons.vue';

    export default {
        name: 'control',
        props: {
            name: {
                type: String,
                default: '',
            },
            label: String,
            beforeAfter: {
                type: String,
                default: 'default',
            },
            tipName: {
                type: String,
                default: 'default',
            },
            tipText: String,
            tipIcon: {
                type: String,
                default: 'default',
            },
            tipIconTwo: {
                type: String,
                default: '',
            },
            tipIconThree: {
                type: String,
                default: '',
            },
            tipSide: {
                type: String,
                default: 'right',
            },
            tipShow: {
                type: Boolean,
                default: true,
            },
            tipWidth: {
                type: String,
                default: '',
            },
            modalName: {
                type: String,
                default: '',
            },
            iconSpace: {
                default: true,
            },
            hideTip: {
                type: Boolean,
                default: false,
            },
            noFlexMargin: {
                type: Boolean,
                default: false,
            },
            tableControl: {
                type: Boolean,
                default: false,
            },
            verticalCentre: {
                type: Boolean,
                default: false,
            },
            isRequired: {
                type: Boolean,
                default: false,
            },

            /**
             * Endpoint.
             *
             * @type {Object}
             */
            endpoint: {
                type: String,
                default: null,
            },
            /**
             * Object.
             *
             * @type {Object}
             */
            payload: {
                default: null,
            },
            /**
             * Option.
             *
             * @type {Object}
             */
            option: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                headsOfLossPath: null,
                customHeadsOfLossPath: null
            }
        },
        computed: {
            ...mapGetters('claim', {
                claimType: 'type',
            }),
            ...mapGetters('lost/headsOfLoss', {
                getLostHeadsOfLossValue: 'getHeadsOfLossValue',
                getLostCustomHeadOfLoss: 'getCustomHeadOfLoss',
            }),
            ...mapGetters('fatal/dependency/headsOfLoss', {
                getDependencyHeadsOfLossValue: 'value',
                getDependencyCustomHeadOfLoss: 'findHeadOfLoss',
            }),
            ...mapGetters('fatal/estate/headsOfLoss', {
                getEstateHeadsOfLossValue: 'value',
                getEstateCustomHeadOfLoss: 'findHeadOfLoss',
            }),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            ...mapGetters('personal/otherPastLosses', {
                getPersonalHeadsOfLossValue: 'value',
                getPersonalCustomHeadOfLoss: 'getCustomHeadOfLoss',
            }),
        },
        components: {
            Modal,
            IconTooltip,
            claimsDashboardIcons
        },
        methods: {
            ...mapActions('modal', ['toggle', 'getModalContent']),
            toggleModal() {
                // Open the Modal Up
                this.toggle(this.modalName);

                // If the Modal has an Endpoint, hit it with the payload
                // set path for head of loss
                this.setHeadsOfLossPath();
                if (this.endpoint && this.option && this.option.key !== null) {
                    this.getModalContent({
                        endpoint: this.endpoint,
                        payload: this.payloadForInterest()
                    });
                }

                if (this.endpoint) {
                    this.getModalContent({
                        endpoint: this.endpoint,
                        payload: this.payload
                    });
                }
            },
            setHeadsOfLossPath() {
                switch (this.claimType) {
                    case 'lost_years':
                        this.headsOfLossPath = 'getLostHeadsOfLossValue';
                        this.customHeadsOfLossPath = 'getLostCustomHeadOfLoss';
                        break;
                    case 'fatal_accident_dependency':
                        this.headsOfLossPath = 'getDependencyHeadsOfLossValue';
                        this.customHeadsOfLossPath = 'getDependencyCustomHeadOfLoss';
                        break;
                    case 'fatal_accident_estate':
                        this.headsOfLossPath = 'getEstateHeadsOfLossValue';
                        this.customHeadsOfLossPath = 'getEstateCustomHeadOfLoss';
                        break;
                    case 'personal_injury':
                        this.headsOfLossPath = 'getPersonalHeadsOfLossValue';
                        this.customHeadsOfLossPath = 'getPersonalCustomHeadOfLoss';
                        break;
                }
            },
            payloadForInterest() {
                let payload = this.payload;

                if (typeof this.option.key !== "undefined") {
                    payload.headOfLoss = {
                        'type': this.option.name,
                        'value': this[this.customHeadsOfLossPath](this.option.key)['value'],
                        'interest': this[this.customHeadsOfLossPath](this.option.key)['interest'],
                    };
                    return payload;
                }

                payload.headOfLoss = {
                    'type': this.option.name,
                    'value': this[this.headsOfLossPath](this.option.name),
                    'interest': this[this.headsOfLossPath](this.option.name + 'Interest')
                };
                return payload;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Control.vue?3d7012a4